export function getHeapSortAnimations(array){
    const animations = [];
    if(array.length<=1)return array;
    heapSortHelper(array,animations);
    return animations;
}

function heapify(array,animations,n,i){
    let largest = i;
    let l = 2*i+1;
    let r = 2*i+2;
    if(l<n){
    animations.push([1,l,largest]);
    animations.push([1,l,largest]);
    }
    if (l < n && array[l] > array[largest]) 
        largest = l;
    if(r<n){ 
    animations.push([1,r,largest]);
    animations.push([1,r,largest]);
    }
    if (r < n && array[r] > array[largest]) 
        largest = r; 
  
    
    if (largest != i) 
    { 
        const temp = array[i];
        array[i] = array[largest];
        array[largest] = temp; 
        animations.push([1,i,largest]);
        animations.push([1,i,largest]);
        animations.push([2,i,largest]);
        heapify(array,animations, n, largest); 
    } 
}


function heapSortHelper(array,animations){
    for(let i=Math.floor(array.length/2)-1;i>=0;i--){
        heapify(array,animations,array.length,i);
    }
    for(let i=array.length-1;i>0;i--){
        const temp = array[0];
        array[0] = array[i];
        array[i] = temp;
        animations.push([1,0,i]);
        animations.push([1,0,i]);
        animations.push([2,0,i]);
        heapify(array,animations,i,0);
    }
}